import { TELTONIKA_FILES_COMPANY } from "./companyIds";

export const globalCompany = {
    id: TELTONIKA_FILES_COMPANY,
    name: "Teltonika Files"
};
